import React from 'react';
import { motion } from 'framer-motion';
import { Maximize2 } from 'lucide-react';
import { Artifact, TYPE_COLORS, TYPE_LABELS, STATUS_COLORS, STATUS_LABELS } from './types';
import { ArtifactPreview } from './ArtifactPreview';
import { ArtifactActions } from './ArtifactActions';
interface ArtifactCardProps {
  artifact: Artifact;
  onExpand?: () => void;
  onApprove?: () => void;
  onRefine?: (comment: string) => void;
  onDiscard?: () => void;
  compact?: boolean;
}
export function ArtifactCard({
  artifact,
  onExpand,
  onApprove,
  onRefine,
  onDiscard,
  compact
}: ArtifactCardProps) {
  const typeColor = TYPE_COLORS[artifact.type];
  const statusColor = STATUS_COLORS[artifact.status];
  const isPending = artifact.status === 'pending' || artifact.status === 'refined';
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className={`bg-[#1c1c22] rounded-xl overflow-hidden cursor-pointer transition-all hover:shadow-lg hover:shadow-black/20 ${isPending ? 'border-l-[3px]' : ''} group`} style={isPending ? {
    borderLeftColor: typeColor
  } : undefined} onClick={onExpand} data-id="element-175">
      {!compact && <div className="w-full" style={{
      aspectRatio: '16/10'
    }} data-id="element-176">
          <div className="w-full h-full overflow-hidden" data-id="element-177">
            <ArtifactPreview artifact={artifact} data-id="element-178" />
          </div>
        </div>}

      <div className="px-4 pt-3 flex items-center justify-between" data-id="element-179">
        <span className="text-[11px]" style={{
        color: typeColor
      }} data-id="element-180">{TYPE_LABELS[artifact.type]}</span>
        <span className="text-[10px] px-1.5 py-0.5 rounded" style={{
        background: statusColor.bg,
        color: statusColor.text
      }} data-id="element-181">
          {STATUS_LABELS[artifact.status]}
        </span>
      </div>

      <div className="px-4 pt-1" data-id="element-182">
        <div className={`text-[#e8e4df] ${compact ? 'text-[13px]' : 'text-[14px]'}`} data-id="element-183">{artifact.title}</div>
        <div className="text-[12px] text-[#8a8680] mt-0.5" data-id="element-184">{artifact.description}</div>
      </div>

      <div className="px-4 pt-2 pb-3 flex items-center justify-between" onClick={e => e.stopPropagation()} data-id="element-185">
        <ArtifactActions artifact={artifact} onApprove={onApprove} onRefine={onRefine} onDiscard={onDiscard} compact={compact} data-id="element-186" />
        {!compact && <button onClick={onExpand} className="text-[#8a8680]/30 group-hover:text-[#8a8680]/80 transition-colors p-1" data-id="element-187">
            <Maximize2 size={14} data-id="element-188" />
          </button>}
      </div>
    </motion.div>;
}